import React, { type ImgHTMLAttributes } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';

export type ImageT = ImgHTMLAttributes<HTMLImageElement>;

export const Image = ({ className, ...props }: ImageT) => {
  const defaultClasses = ['max-w-full', 'max-h-full'];

  return <img className={cn(defaultClasses, className)} {...props} />;
};
